export const GET_BUSINESS_LIST = 'BUSINESS_TAX/GET_BUSINESS_LIST';
export const GET_BUSINESS_INFO = 'BUSINESS_TAX/GET_BUSINESS_INFO';
export const GET_LINE_BUSINESS = 'LINE_BUSINESS/get_line_business';
export const REJECT_BUSINESS = 'BUSINESS_TAX/REJECT_BUSINESS';

export const GET_BUSINESS_TRANSACTION_HISTORY_LIST = 'BUSINESS/GET_BUSINESS_TRANSACTION_HISTORY_LIST';
export const GET_BUSINESS_TRANSACTION_HISTORY_ITEM = 'BUSINESS/GET_BUSINESS_TRANSACTION_HISTORY_ITEM';

export const GET_BUSINESS_FIX_TAX_LIST = 'BUSINESS_TAX/GET_BUSINESS_FIX_TAX_LIST';
export const GET_FIX_TAX_LIST = 'BUSINESS_TAX/GET_FIX_TAX_LIST';
export const GET_FIX_TAX_INFO = 'BUSINESS_TAX/GET_BUSINESS_FIX_TAX_INFO';
export const ADD_BUSINESS_FIX_TAX = 'BUSINESS_TAX/ADD_BUSINESS_FIX_TAX';
export const UPDATE_FIX_TAX = 'BUSINESS_TAX/UPDATE_FIX_TAX';
export const DELETE_FIX_TAX = 'BUSINESS_TAX/DELETE_BUSINESS_FIX_TAX';

export const GET_OTHER_FEE_LIST = 'BUSINESS/GET_OTHER_FEE_LIST';

export const COMPUTE_BUSINESS_ACTIVITY = 'BUSINESS/COMPUTE_BUSINESS_ACTIVITY';
export const COMPUTE_FIX_TAX = 'BUSINESS/COMPUTE_FIX_TAX';
export const COMPUTE_OTHER_FEE = 'BUSINESS/COMPUTE_OTHER_FEE';
export const APPROVE_BUSINESS = 'BUSINESS_TAX/APPROVE_BUSINESS';

export const START_ASSESSMENT = 'BUSINESS_TAX/START_ASSESSMENT';
